<template>
    <div height="24">
        <v-menu>
            <template v-slot:activator="{ on }">
                <v-btn height="24" v-if="!value.completed" v-on:click.prevent v-on="on" text icon small >
                    <v-icon>input</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item
                    v-if="moment(value.date).isSameOrAfter(today)"
                    @click="moveTo(nextDay)"
                >
                    <v-list-item-title>Move to {{calendarFormat(nextDay)}}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="moment(value.date).isAfter(today)" @click="moveTo(today)">
                    <v-list-item-title>Move to today</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectDate" v-if="showDateSelector">
                    <v-list-item-title>
                        Move to date
                        <v-icon>event</v-icon>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-dialog v-model="dateSelector" full-width width="290px">
            <v-date-picker
                :min="today"
                :value="moveToDate"
                :max="maxDate"
                @input="dateSelector = false; moveTo($event)"
                no-title
            ></v-date-picker>
        </v-dialog>
    </div>
</template>
<script>
import moment from 'moment';
import business from 'moment-business';
import { DateFormat } from '../../../plugins/date-filter';

export default {
    props: {
        value: { required: true },
        type: { required: true },
        max: { required: false }
    },
    data() {
        return {
            today: moment().format(DateFormat.Canonical),
            dateSelector: false,
            moveToDate: null
        };
    },
    computed: {
        nextDay() {
            let date = moment(this.value.date);

            if (moment(this.value.date).isBefore(this.today)) {
                date = moment(this.today);
            } else if (moment(this.value.date).isSameOrAfter(this.today)) {
                date = business.addWeekDays(moment(this.value.date), 1);
            }

            return date.format(DateFormat.Canonical);
        },
        maxDate() {
            if (this.max) {
                return moment(this.max).format(DateFormat.Canonical);
            }
            return null;
        },
        showDateSelector() {
            if (!this.max) {
                return true;
            }
            return moment(this.today).isSameOrBefore(this.maxDate);
        }
    },
    methods: {
        calendarFormat(date) {
            return moment(date).calendar(null, {
                sameDay: '[today]',
                nextDay: '[tomorrow]',
                nextWeek: 'dddd',
                sameElse: `[next day] (${DateFormat.DefaultDisplay})`,
                lastDay: '[yesterday]', // should never be needed
                lastWeek: '[last] dddd' // should never be needed
            });
        },
        moveTo(date) {
            this.$confirmCancel.show(this.title(), this.message(), 'Move it');
            this.$confirmCancel.$on('confirm-cancel', confirmed => {
                if (!confirmed) {
                    return;
                }
                this.$emit('move', { service: this.value, date });
            });
        },
        selectDate() {
            this.dateSelector = true;
        },
        title() {
            if (this.type == 'service') {
                return `I sure hope you know what you're doing!`;
            }
        },
        message(date) {
            if (this.type == 'service') {
                return `<p>Moving ${this.value.unitNumber} to ${moment(date).format(DateFormat.DefaultDisplay)}
will mark the service as "manually moved".</p
<p>That means services for this unit <b>won't get automatically predicted</b>
again until this service gets completed.</p>
<p>Manually moving a service <b>might move it past the unit\'s service tolerance</b>.</p>`;
            }

            if (this.type == 'defect') {
                return `<p>Are you sure you want to move <strong>${this.value.unitNumber} - "${this.value.description}"</strong> to ${moment(date).format(DateFormat.DefaultDisplay)}?</p>`;
            }

            if (this.type == 'campaign') {
                return `<p>Are you sure you want to move <strong>${this.value.unitNumber} in "${this.value.campaignName}"</strong> to ${moment(date).format(DateFormat.DefaultDisplay)}?</p>`;
            }
        }
    }
};
</script>
